import { Component,ViewEncapsulation, Input, OnInit , ElementRef,Renderer2} from '@angular/core';

import * as screenfull from 'screenfull';

import * as Plotly from 'plotly.js';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'plotlychart',
  template: ``,
  encapsulation: ViewEncapsulation.None
})


export class PlotlyComponent implements OnInit {
    @Input() data: any;
    @Input() layout: any;
    @Input() options: any;
    @Input() shapes: any;
    @Input() displayRawData: boolean;    
    @Input() displayZData: boolean; 

  constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {

        const nativeElement: HTMLElement = this.el.nativeElement;
        const plotDiv = this.renderer.createElement('div');

        plotDiv.style.width = '100%';
        plotDiv.style.height = '100%';
        
        plotDiv.addEventListener('click', () => {
            if (screenfull.enabled) {
                screenfull.request();
            }
        });

        this.renderer.appendChild(nativeElement, plotDiv)

        let plotData : any[]  = [];

        this.data.forEach(element => {
          
          let plotElement : any = {};

          plotElement = element;
          plotElement.connectgaps = true;
  
          if(this.displayRawData)
          {
              plotElement.mode = 'lines+text';
              plotElement.text = element.y;
              plotElement.textposition = 'top left';
              plotElement.textfont = {
                family: 'sans serif',
                size: 8,
                color: '#1f77b4'
              };
          }

          plotData.push(plotElement);

        });
        
        if (this.shapes != null){

           //this.layout.shapes=  [];

           this.shapes.forEach(shapeData => {
            
            this.data.forEach(trace => {
                
                if(trace.Year === shapeData.Year){

                    let shape : any = {};
                    shape.type =  'line',
                    shape.xref = 'x',
                    shape.yref =  'y',
                    shape.x0 =  trace.x.indexOf(shapeData.Date),
                    shape.y0 =  0,
                    shape.x1 =  trace.x.indexOf(shapeData.Date),
                    shape.y1 =  16,
                    shape.line =  {
                      color: shapeData.Color,
                      width: 1.3
                    }
        
                    this.layout.shapes.push(shape)
                }
                
              });
            });

        }

        Plotly.newPlot(plotDiv, plotData, this.layout, this.options);

        if(this.displayZData)
        {
            plotDiv.on('plotly_hover', function(data){

                var infotext = data.points.map(function(d){
     
                 var infotext = d.data.z[d.pointIndex];
     
                     var elm = '<div Id="VitData_'+d.x.toString().replace(/ /g, '')+'_'+d.y.toPrecision(3) +'"' +
                     'style="z-index: 2;position: relative;top: -450px;">'+infotext+
                     '</div>';
                      $(elm).appendTo(plotDiv);
     
                });
              })
              .on('plotly_unhover', function(data){
     
                 var infotext = data.points.map(function(d){
     
                    var Id="VitData_"+d.x.toString().replace(/ /g, '')+"_"+d.y.toPrecision(3);
     
                    var div = document.getElementById(Id);
                    div.remove();
                });
             });
        }
       

        $(plotDiv).find('g.pointtext').find('text').css('visibility', 'hidden');
    }

}



// WEBPACK FOOTER //
// ./src/app/helpers/plotly.component.ts